import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authSession } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin-login", { replace: true });
      return;
    }
    const session_id = match[1];
    authSession(session_id)
      .then(() => {
        // Clean the hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true });
      })
      .catch(() => navigate("/admin-login", { replace: true }));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-neutral-500 text-sm tracking-[0.2em] uppercase">
      Autenticazione in corso...
    </div>
  );
}
